import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#1877F2",
  viewBox: "0 0 22.437 22.3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M22.437 11.218a11.218 11.218 0 1 0-12.97 11.081v-7.837H6.618V11.22h2.849V8.748c0-2.811 1.675-4.363 4.235-4.363a17.307 17.307 0 0 1 2.511.218v2.759h-1.414a1.622 1.622 0 0 0-1.829 1.752v2.1h3.112l-.5 3.242H12.97v7.839a11.221 11.221 0 0 0 9.467-11.077Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }